import gql from "graphql-tag";

/**
 * Moves one part order item between pickup states.
 *
 * Send `Collected` to confirm a pickup; the backend stamps `pickedUpAt`/`pickedUpBy`.
 * Never send `Picked_Up` — despite the name it is the legacy default and means the part
 * is still at the store.

 */
export const UPDATE_PART_ORDER_ITEM_STATUS = gql`
  mutation updatePartOrderItemStatus($id: ID!, $status: PartOrderItemStatus!) {
    updatePartOrderItemStatus(id: $id, status: $status) {
      id
      status
      pickedUpAt
      pickedUpBy
    }
  }
`;
